import MProjects from 'views/ProjectsManagement/MProjects';
import MPApproved from 'views/ProjectsManagement/MPApproved';
import MPPending from 'views/ProjectsManagement/MPPending';
import MPRejected from 'views/ProjectsManagement/MPRejected';
import MPArchived from 'views/ProjectsManagement/MPArchived';

const ManagmentProjectsRouters = [
  {
    path: 'projectsManagement',
    element: <MProjects />
  },
  {
    path: 'approveManagement',
    element: <MPApproved />
  },
  {
    path: 'pendingManagement',
    element: <MPPending />
  },
  {
    path: 'rejectedManagement',
    element: <MPRejected />
  },
  {
    path: 'archivedManagement',
    element: <MPArchived />
  }
];

export default ManagmentProjectsRouters;
